import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCatalogStates, getCatalogCities } from '../../services/api';
// import { getLawyerSpecialties } from '../../services/api'; // Para futuro uso

// Async thunks
export const fetchStates = createAsyncThunk(
  'catalog/fetchStates',
  async (countryId = 142, { rejectWithValue }) => {
    try {
      const response = await getCatalogStates(countryId);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchCities = createAsyncThunk(
  'catalog/fetchCities',
  async (stateId, { rejectWithValue }) => {
    try {
      const response = await getCatalogCities(stateId);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchLanguages = createAsyncThunk(
  'catalog/fetchLanguages',
  async (_, { rejectWithValue }) => {
    try {
      // Por ahora usamos idiomas estáticos, pero mantenemos la estructura
      // para futuro cambio a backend
      const staticLanguages = [
        { id_language: '1', language: 'Español' },
        { id_language: '2', language: 'Inglés' },
        { id_language: '3', language: 'Francés' },
        { id_language: '4', language: 'Alemán' },
        { id_language: '5', language: 'Portugués' },
        { id_language: '6', language: 'Italiano' },
        { id_language: '7', language: 'Chino' },
        { id_language: '8', language: 'Japonés' },
        { id_language: 'otro', language: 'Otro' },
      ];

      // Simular delay de red para mantener consistencia
      await new Promise(resolve => setTimeout(resolve, 100));

      return staticLanguages;

      // TODO: Cambiar a backend cuando esté disponible
      // const response = await getLawyerLanguages();
      // return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchSpecialties = createAsyncThunk(
  'catalog/fetchSpecialties',
  async (_, { rejectWithValue }) => {
    try {
      // Por ahora usamos especialidades estáticas, pero mantenemos la estructura
      // para futuro cambio a backend
      const staticSpecialties = [
        { id: 'derecho-familiar', name: 'Derecho Familiar' },
        { id: 'derecho-penal', name: 'Derecho Penal' },
        { id: 'derecho-laboral', name: 'Derecho Laboral' },
        { id: 'derecho-mercantil', name: 'Derecho Mercantil' },
        { id: 'derecho-civil', name: 'Derecho Civil' },
        { id: 'derecho-fiscal', name: 'Derecho Fiscal' },
        { id: 'derecho-inmobiliario', name: 'Derecho Inmobiliario' },
        { id: 'derecho-corporativo', name: 'Derecho Corporativo' },
      ];

      // Simular delay de red para mantener consistencia
      await new Promise(resolve => setTimeout(resolve, 100));

      return staticSpecialties;

      // TODO: Cambiar a backend cuando esté disponible
      // const response = await getLawyerSpecialties();
      // return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  states: {
    data: [],
    loading: false,
    error: null,
  },
  cities: {
    data: [],
    loading: false,
    error: null,
  },
  languages: {
    data: [],
    loading: false,
    error: null,
  },
  specialties: {
    data: [],
    loading: false,
    error: null,
  },
};

const catalogSlice = createSlice({
  name: 'catalog',
  initialState,
  reducers: {
    clearCities: state => {
      state.cities.data = [];
      state.cities.error = null;
    },
    clearErrors: state => {
      state.states.error = null;
      state.cities.error = null;
      state.languages.error = null;
      state.specialties.error = null;
    },
  },
  extraReducers: builder => {
    // States
    builder
      .addCase(fetchStates.pending, state => {
        state.states.loading = true;
        state.states.error = null;
      })
      .addCase(fetchStates.fulfilled, (state, action) => {
        state.states.loading = false;
        state.states.data = action.payload;
      })
      .addCase(fetchStates.rejected, (state, action) => {
        state.states.loading = false;
        state.states.error = action.payload;
      })
      // Cities
      .addCase(fetchCities.pending, state => {
        state.cities.loading = true;
        state.cities.error = null;
      })
      .addCase(fetchCities.fulfilled, (state, action) => {
        state.cities.loading = false;
        state.cities.data = action.payload;
      })
      .addCase(fetchCities.rejected, (state, action) => {
        state.cities.loading = false;
        state.cities.error = action.payload;
      })
      // Languages
      .addCase(fetchLanguages.pending, state => {
        state.languages.loading = true;
        state.languages.error = null;
      })
      .addCase(fetchLanguages.fulfilled, (state, action) => {
        state.languages.loading = false;
        state.languages.data = action.payload;
      })
      .addCase(fetchLanguages.rejected, (state, action) => {
        state.languages.loading = false;
        state.languages.error = action.payload;
      })
      // Specialties
      .addCase(fetchSpecialties.pending, state => {
        state.specialties.loading = true;
        state.specialties.error = null;
      })
      .addCase(fetchSpecialties.fulfilled, (state, action) => {
        state.specialties.loading = false;
        state.specialties.data = action.payload;
      })
      .addCase(fetchSpecialties.rejected, (state, action) => {
        state.specialties.loading = false;
        state.specialties.error = action.payload;
      });
  },
});

export const { clearCities, clearErrors } = catalogSlice.actions;

// Selectors
export const selectStates = state => state.catalog.states;
export const selectCities = state => state.catalog.cities;
export const selectLanguages = state => state.catalog.languages;
export const selectSpecialties = state => state.catalog.specialties;

export default catalogSlice.reducer;
